{
  "login": {
    "submit": "Acceder"
  },
  "games_names": {
    "colors": "Descubriendo colores",
    "shapesemptyboard": "Vacía el tablero",
    "shapes": "Descubriendo formas",
    "shapescoloring": "Coloreando formas",
    "shapesdrag": "Colocando formas",
    "shapesjigsaw": "Puzzle de formas",
    "shapesmemory": "Colores",
    "shapeswhichone": "¿Qué forma?",
    "shapestrace": "Trazando formas",
    "shapesfalling": "Reconocimiento de formas",
    "colorscandy": "Golosinas de colores",
    "colorsmemory": "Colores",
    "balloonsempty": "Quitando globos",
    "balloonspop": "Explotando globos",
    "shapeshalf": "Media forma",
    "shapessmallorbig": "Grande o pequeño",
    "shapessmalltobig": "Grande y pequeño",
    "numbers": "Descubriendo números",
    "numbersdrag": "Colocando números",
    "numberscounting": "Un, dos, tres",
    "numbershowmany": "¿Cuántos animales",
    "numbersfalling": "Burbujas de números",
    "numbersmemory": "Colores",
    "numberssort": "Las cajas",
    "numberswhichone": "¿Qué número?",
    "shapestangram": "Tangram de formas",
    "numbersrunning": "¡Conejos al tren!",
    "numbersbingo": "Bingo de números",
    "numbersfindthepath": "Camino de números",
    "numbersbalance": "Balanza",
    "numberspizza": "Pizza sabor sumas",
    "numbersadd": "Sumando",
    "numberssubtract": "Restando",
    "animalsmemory": "Colores",
    "animalswhichone": "¿Qué animal?",
    "animals": "Descubriendo animales",
    "animalssounds": "Escucha la fauna",
    "animalsmixthem": "Mezcla el animal",
    "animalsbingo": "Bingo de animales",
    "animalsdragtoplace": "Silueta de animales",
    "animalsfood": "Alimenta a los animales",
    "animalsrunning": "¡Animales a bordo!",
    "animalsconnect": "Dibujando con puntos",
    "animalsjigsaw": "Puzzle de animales",
    "numberstrace": "Trazando números",
    "animalsmatchfood": "Animal y alimento",
    "lettersmatchupperlower": "Emparejando letras",
    "letters": "Descubrimos las letras",
    "lettersmissing": "Escribe en el hueco",
    "letterssort": "Ordena las letras",
    "lettersjigsawslider": "Rompecabezas hogar",
    "letterstraceupper": "Trazando letras mayúsculas",
    "letterstracelower": "Trazando letras minúsculas",
    "letterschoosecorrect": "¡Esa es la palabra!",
    "lettersmemory": "Colores",
    "lettersmatchimage": "Objeto y letra",
    "lettersbingo": "Bingo de letras",
    "lettersdrag": "Colocando letras",
    "lettersupperfindthepath": "Camino de letras",
    "musicalinstruments": "Instrumentos musicales",
    "musicplayinstruments": "¡A componer!",
    "animalsbrowse": "Ficha este animal",
    "musichero": "Sigue la canción",
    "musicnotesfalling": "Notas voladoras",
    "letterscollectstuff": "Cosas de casa",
    "numberssnake": "El gusano de los números",
    "numbersdressbigsmall": "Oso grande, mono pequeño",
    "numberssupermarket": "Un día en el supermercado",
    "animalssoundsgrid": "Fauna sonora",
    "castlepatterns": "El castillo de patrones",
    "numbersaddscales": "Balanza de sumas",
    "bodydiscovery": "Cara y cuerpo",
    "numbersspaceship": "La nave de los números",
    "transport": "Descubrimos los transportes",
    "colorpatterns": "Patrones de color",
    "musicwhichone": "¿Qué instrumento?",
    "bodytangram": "Tangram corporal",
    "musicsimon": "Secuencia musical",
    "colorsmix": "Mezcla de colores",
    "foodslider": "Descubrimos la comida",
    "clothes": "Descubrimos la ropa",
    "seasons": "Las estaciones",
    "coloringpixels": "Colorea con números",
    "shapesclassify": "Clasificación de formas",
    "numberswhohasmore": "Los glotones",
    "positioningdiscovery": "¿Dónde está Jane?",
    "songheadandshoulders": "Colores",
    "letterscookies": "Galletas de letras",
    "lettersshopping": "La tienda de las letras",
    "bodyslider": "Descubrimos el cuerpo",
    "identifyactionemotions": "Acción y emoción",
    "whathappensnext": "¿Qué pasa después?",
    "setthealarmclock": "Las agujas del reloj",
    "animalscoloring": "Colorea animales",
    "characterscoloring": "Colorea Kokoros",
    "rhymesshop": "La tienda de rimas",
    "numberseatsubtractions": "Me como una",
    "numbersbuildawallinblocks": "El muro de las sumas",
    "numberslosingitems": "La mochila de las restas",
    "numbersgrabthefruit": "Cesta de fruta",
    "environmentfishingrubbish": "Limpia el mar",
    "colorsorchard": "El huerto",
    "spotdifferences": "Las diferencias",
    "charactershideandseek": "¿Dónde están los Kokoros?",
    "characterscostumes": "Disfrázate",
    "carjam": "El parking",
    "treasuremap": "Mapa del tesoro",
    "findindarkroom": "La linterna",
    "weatherwhichone": "¿Qué clima?",
    "rightleftdelivery": "Bus sube y baja",
    "flysolarsystem": "El sistema solar",
    "flycontinents": "Los continentes",
    "flyoceans": "Los océanos",
    "animalsheneggs": "El huevo y la gallina",
    "animalssoundswhichone": "Escucha al animal",
    "numberswheelfortune": "La noria",
    "numbersmoneyclassify": "Las huchas",
    "numbershowmanyinbarn": "¿Cuántos entran?",
    "numbersalgebroid": "Rompeladrillos de mates",
    "coloroid": "Rompeladrillos de colores",
    "rightleftdeliverycolors": "Reparto de colores",
    "numberspotions": "Poción de números",
    "foodcook": "Cocina la comida",
    "bodyshower": "Lávate el cuerpo",
    "bodyfacewash": "Lávate la cara",
    "christmasmusichero": "Piano navideño",
    "racingcolors": "Colores",
    "christmasdecoratetree": "Decora el árbol",
    "pillchest": "Colores",
    "christmascoloring": "Colorea la navidad",
    "christmasmemory": "Memoriza la navidad",
    "covidgame": "Colores",
    "ramonelcamaleon": "Ramón el Camaleón",
    "discoverycolors": "Descubre los colores",
    "memory": "Memoriza",
    "miceandcoding": "Guía al ratón",
    "drawthepath": "Dibuja el recorrido",
    "tangram": "Tangram Lego",
    "zamburguesas": "Zamburguesas",
    "pizzafor2": "Pizza para dos",
    "hideandseek": "El escondite",
    "whichage": "¿Cuál es su edad?",
    "letterjigsawsliderjobs": "Rompecabezas profesiones",
    "whichemotion": "¿Qué emoción?",
    "letterjigsawsliderdinos": "Rompecabezas dinosaurious",
    "monsterparts": "Cuenta los monstruos",
    "thesenses": "Los sentidos",
    "aboutschool": "Sobre la escuela",
    "halloweenbingo": "Bingo de Halloween",
    "letterjigsawsliderfood": "Rompecabezas alimentos",
    "letterjigsawsliderinsects": "Rompecabezas insectos",
    "lettersjigsawslidervehicles": "Rompecabezas vehículos",
    "lettersjigsawslidermarineanimals": "Rompecabezas marino",
    "christmasbingo": "Bingo navideño",
    "lettersjigsawchristmas": "Rompecabezas navideño",
    "wedraw": "Dibujamos",
    "whereisthis": "¿Dónde están?",
    "emotionsinarow": "Emociones en línea",
    "lettersmessvowels": "Lío de vocales",
    "coloringpixelvowels": "Colorea con vocales",
    "wordworm": "Gusanito de palabras",
    "lettersskymap": "Mapa estelar de letras",
    "letterssorthome": "Ordena las letras: En casa",
    "letterssortanimals": "Ordena las letras: Animales",
    "letterssortcity": "Ordena las letras: En la ciudad",
    "insectsbingo": "Bingo de insectos",
    "emotionsbingo": "Bingo de emociones",
    "wordsearchanimals": "Busca palabras: Animales",
    "marinebingo": "Bingo de animales marinos",
    "jobsbingo": "Bingo de profesiones",
    "lettersmissinghome": "Completa las palabras: Hogar",
    "easterbingo": "Bingo de pascua",
    "springbingo": "Bingo de primavera",
    "lettersjigsawsliderspring": "Rompecabezas primaveral",
    "lettersmissinginsects": "Completa las palabras: Insectos",
    "lettersmissingfood": "Completa las palabras: Comida",
    "lettersmissingsports": "Completa las palabras: Deportes",
    "cutwords": "Corta palabras",
    "quijotebingo": "Bingo Quijote",
    "theabc": "El ABC",
    "realfooder": "Comida real",
    "organizesentence": "Organiza la frase",
    "emotionmatch": "Empareja la emoción",
    "fairytales": "Cuentos de hadas",
    "animalshadow": "Sombras de animales",
    "coloringpixelconsonantsone": "Colorea píxeles con consonantes",
    "wordsearchfood": "Busca palabras: Comida",
    "wordsearchjobs": "Busca palabras: Profesiones",
    "tapthefish": "Atrapa el pez",
    "howmany": "¿Cuántos hay?",
    "guesswho": "¿Quién es quién?",
    "pooptime": "Hora de hacer caca",
    "unboxing": "Ordena la casa",
    "emotionssudoku": "Sudoku de emociones",
    "talktowin": "Habla y gana la carrera",
    "wordsearchsummer": "Busca palabras: Verano",
    "summerinarow": "Verano en línea",
    "sportsinarow": "Deportes en raya",
    "organizethesentence": "Organiza la frase",
    "wedrawhalloween": "Dibujamos Halloween",
    "additionsmess": "Lío de sumas",
    "numbersmess": "Lío de números",
    "techinarow": "Tecnología en raya",
    "veggiesinarow": "Vegetales en raya",
    "kokorocreator": "Creador de Kokoros",
    "drawthepathwinter": "Traza el camino de invierno",
    "rainbowbeehive": "Colmena Arcoíris",
    "imitateemotions": "Imita la emoción: Principiante",
    "imitateemotionsmedium": "Imita la emoción: Intermedio",
    "imitateemotionshard": "Imita la emoción: Experto",
    "findtheoddemotion": "Encuentra las diferencias: emociones",
    "numberscomp": "Mayor o menor",
    "treasurehunt": "Búsqueda del tesoro en el bosque",
    "intrudersearch": "Encuentra el intruso",
    "shapesoflife": "La forma de las cosas",
    "clothingfitsyou": "¿Dónde me lo pongo?",
    "thatistheduck": "¡Ese es el pato!",
    "eddiecolors": "Eddie y los Colores",
    "thebigchain": "La Gran Cadena",
    "mesozoicera": "Era Mesozóica",
    "wedrawempathy": "Dibujamos la empatía",
    "candychameleon": "Camaleón Caramelo",
    "vintagetech": "Tecnología Vintage",
    "discoverrobots": "Descubriendo robots",
    "icecreamfor2": "Helado para dos",
    "whereisthisdog": "¿Dónde está el perro?",
    "whereisthiscat": "¿Dónde está el gato?",
    "masterofsyllables": "Maestro de las sílabas",
    "drawyourpuzzleschool": "Dibuja tu puzle del cole",
    "goodhabits": "Buenos hábitos",
    "findindarkroomstrangethings": "Encuentra la cosa extraña",
    "wordchain": "Cadena de palabras",
    "marinelifecount": "Conteo de vida marina",
    "winter_fairytales": "Cuentos de Invierno",
    "organizerubbish": "Reciclando",
    "whichjob": "¿Quien es quien? Profesiones"
  },
  "games_desc": {
    "colors": "Pulsa en las flechas para descubrir los colores y sus nombres",
    "shapesemptyboard": "Haz que las formas geométricas del tablero desaparezcan",
    "shapes": "Pulsa en las flechas para descubrir las formas geométricas y sus nombres",
    "shapescoloring": "Colorea las formas geométricas de estos dibujos como más te apetezca",
    "shapesdrag": "Arrastra las formas geométricas hasta su silueta",
    "shapesjigsaw": "Junta las piezas del puzzle para ver las imágenes completas",
    "shapesmemory": "Colores",
    "shapeswhichone": "Escoge la figura geométrica que se te pide",
    "shapestrace": "Traza la forma de las figuras geométricas para aprender a dibujarlas",
    "shapesfalling": "Pulsa las figuras geométricas que caen según corresponda",
    "colorscandy": "Clasifica los caramelos y mételos en sus dispensadores según su color",
    "colorsmemory": "Colores",
    "balloonsempty": "Explota los globos según su color hasta que la pantalla se vacíe",
    "balloonspop": "Pulsa y explota los globos que flotan según su color",
    "shapeshalf": "Coloca las piezas que están cortadas sobre su otra mitad para formar figuras enteras",
    "shapessmallorbig": "Elige la forma según si es grande o pequeña",
    "shapessmalltobig": "Ordena las formas según su tamaño, arrastrándolas",
    "numbers": "Pulsa las flechas para descubrir los números de 1 al 6",
    "numbersdrag": "Arrastra el número a su correspondiente silueta",
    "numberscounting": "Aprende a sumar pulsando los patitos",
    "numbershowmany": "Pulsa en el número que corresponde al número de animales que ves",
    "numbersfalling": "Pulsa en las burbujas que van flotando con los números correctos",
    "numbersmemory": "Colores",
    "numberssort": "Arrastra las cajas a los monos de diferentes tamaños según si su número es mayor o menor",
    "numberswhichone": "¿Qué número te están pidiendo? ¿Sabrías identificarlo?",
    "shapestangram": "Identifica figuras geométricas simples y colócalas en su lugar correcto",
    "numbersrunning": "Cada conejo tiene un número ¿Serías capaz de colocar cada uno en el vagón que le corresponde?",
    "numbersbingo": "Cuenta los animales que aparecen y pulsa los números hasta formar líneas en el tablero",
    "numbersfindthepath": "Pulsa los números por órden para trazar el camino hasta casa",
    "numbersbalance": "Equilibra la balanza para ayudar a Alan a llegar al tesoro",
    "numberspizza": "Coloca en la pizza el número exacto de ingredientes que necesita Alan",
    "numbersadd": "Aprende a calcular sumas sencillas con la magia de Alan",
    "numberssubtract": "Aprende a calcular restas sencillas con la magia de Alan",
    "animalsmemory": "Colores",
    "animalswhichone": "Escoge correctamente el animal que se te pide",
    "animals": "Pulsa en las flechas para descubrir el nombre de los animales y su aspecto",
    "animalssounds": "Selecciona un hábitat para escuchar cómo suenan los animales que viven en él",
    "animalsmixthem": "Ordena estas imágenes hasta que veas un dibujo completo de un animal",
    "animalsbingo": "Reconoce y selecciona los animales que se te piden hasta crear líneas",
    "animalsdragtoplace": "Arrastra los animales en su hábitat correcto hasta su silueta",
    "animalsfood": "Arrastra la comida hasta los animales, pero dales sólo lo que ellos suelen comer",
    "animalsrunning": "Arrastra los animales hasta el barco para que viajen con Nikola",
    "animalsconnect": "Conecta los puntos siguiendo el orden para crear un dibujo",
    "animalsjigsaw": "Arrastra las piezas al sitio correcto para completar la imagen",
    "numberstrace": "Elige un número y sigue su trazo para aprender a escribirlo.",
    "animalsmatchfood": "Empareja el animal con el alimento que come",
    "lettersmatchupperlower": "Empareja las letras mayúsculas con su letra minúscula",
    "letters": "Pulsa en las flechas para descubrir el nombre de las letras y su aspecto",
    "lettersmissing": "Arrastra la letra que falta para completar el nombre de los animales",
    "letterssort": "Ordena las letras para formar los nombres de los alimentos",
    "lettersjigsawslider": "Coloca bien las piezas para descubrir los objetos cotidianos y su nombre",
    "letterstraceupper": "Elige una letra mayúscula y sigue su trazo para aprender a escribirla",
    "letterstracelower": "Elige una letra minúscula y sigue su trazo para aprender a escribirla",
    "letterschoosecorrect": "Elije la palabra correcta que corresponde a la imagen",
    "lettersmemory": "Elije la palabra correcta que corresponde a la imagen",
    "lettersmatchimage": "Empareja los objetos con la primera letra de su nombre",
    "lettersbingo": "Selecciona la letra por la que empieza el objeto que aparece hasta crear líneas",
    "lettersdrag": "Arrastra las letras mayúsculas a los huecos con su forma para aprender a reconocerlas",
    "lettersupperfindthepath": "Sigue el camino de puntos pulsando las letras contiguas para llegar a casa",
    "musicalinstruments": "Pulsa en las flechas para descubrir los instrumentos musicales",
    "musicplayinstruments": "Elige cualquiera de los instrumentos para tocar libremente y practicar tu creatividad musical",
    "animalsbrowse": "Pulsa en los animales para aprender su nombre y su aspecto",
    "musichero": "Toca las notas que se indican en el teclado para hacer sonar la canción.",
    "musicnotesfalling": "Pulsa las notas que caen para hacer sonar la canción",
    "letterscollectstuff": "Encuentra en estas habitaciones los objetos cotidianos que se te piden",
    "numberssnake": "Arrastra al gusano hacia los números para crear la secuencia y hacer que el gusano crezca y se transforme en mariposa",
    "numbersdressbigsmall": "Aprende a diferenciar entre grande y pequeño vistiendo al oso y al mono",
    "numberssupermarket": "Aprende a hacer la lista de la compra y a comprar en el supermercado ¡Recuerda los pasos a seguir!",
    "animalssoundsgrid": "Aprende los sonidos de los animales pulsando en cada uno de ellos",
    "castlepatterns": "Sigue los patrones de formas y colores para ayudar a Alan a cruzar el puente",
    "numbersaddscales": "Equilibra la balanza arrastrando el resultado de la suma",
    "bodydiscovery": "Pulsa en los personajes para descubrir el nombre de las partes del cuerpo",
    "numbersspaceship": "Elige el número que debería ir en esa secuencia para que Alan descubra el código de la nave espacial",
    "transport": "Pulsa las flechas para descubrir tipos de vehículos y su aspecto",
    "colorpatterns": "Elige la maleta del color que sigue el patrón de la cinta trasportadora",
    "musicwhichone": "Escucha los instrumentos y elige el que haya sonado",
    "bodytangram": "Coloca las partes del cuerpo de estos dibujos en su posición correcta",
    "musicsimon": "Memoriza la secuencia musical que está tocando Wolfie y tócala tú después",
    "colorsmix": "Mezcla los colores de la manera correcta para que el dibujo se coloree",
    "foodslider": "Pulsa las flechas para descubrir tipos de alimentos y su aspecto",
    "clothes": "Pulsa las flechas para descubrir tipos de ropa y su aspecto",
    "seasons": "Descubre las estaciones y su clima",
    "coloringpixels": "Identifica los colores de los píxeles de los dibujos según su número",
    "shapesclassify": "Lleva los objetos hasta la cesta correcta según su forma",
    "numberswhohasmore": "Pulsa en el animal que calcules que tiene más o menos comida",
    "positioningdiscovery": "Aprende preposiciones encontrando en qué posición se encuentra Jane",
    "songheadandshoulders": "Colores",
    "letterscookies": "Cocina estas galletas con las formas de letras que prefieras y decóralas",
    "lettersshopping": "Jane sólo puede comprar los objetos que empiezan por determinadas letras ¿Sabes identificarlos?",
    "bodyslider": "Toca en las flechas para descubrir y aprender nombres de partes del cuerpo y cómo son",
    "identifyactionemotions": "Se abre el telón ¿Qué están sintiendo o haciendo los Kokoros?",
    "whathappensnext": "Elige la imagen con la acción siguiente que va a realizar Jane",
    "setthealarmclock": "Mueve las agujas del reloj y marca la hora correcta para que Alan no llegue tarde a sus actividades",
    "animalscoloring": "Pinta estos animales de la manera que más te guste",
    "characterscoloring": "Pinta a los Kokoros de la manera que más te guste",
    "rhymesshop": "Elige los objetos que riman con otros en esta tienda tan variada",
    "numberseatsubtractions": "Haz la resta y averigua cuántos alimentos quedan en la mesa después de que Alan haya merendado",
    "numbersbuildawallinblocks": "Construye muros con el número de ladrillos que se necesitan ¡Pero cuidado con los grupos, no te pases de ladrillos!",
    "numberslosingitems": "¡Oh no! Alan tiene un agujero en la mochila ¿Cuántas frutas ha perdido?",
    "numbersgrabthefruit": "Reparte el número de frutas que necesita cada cesta",
    "environmentfishingrubbish": "Ayuda a Nikola a limpiar los mares de basura recogiendo lo que no corresponde",
    "colorsorchard": "Recoge las verduras según el color que aparezca cuanto tires el dado",
    "spotdifferences": "¿Puedes encontrar las diferencias entre las dos imágenes?",
    "charactershideandseek": "Ejercita la atención encontrando a los Kokoros en el escenario ¡Están muy escondidos!",
    "characterscostumes": "Ayuda a los Kokoros a elegir los disfraces que más te gusten y aprende a vestirlos",
    "carjam": "Desliza los coches para que Nikola pueda salir del aparcamiento",
    "treasuremap": "Coloca las piezas para hacer el camino correcto hasta el tesoro",
    "findindarkroom": "Busca con la linterna los objetos ocultos que se te piden en estos lugares cotidianos",
    "weatherwhichone": "Aprende a decir qué clima hace fuera de casa",
    "rightleftdelivery": "Guía al autobús para recoger a los Kokoros en las paradas, identificando entre arriba y abajo",
    "flysolarsystem": "Ayuda a Nikola a llegar de un planeta a otro, aprende cómo se llaman y memorízalos",
    "flycontinents": "Ayuda a Nikola a llegar de un continente a otro, aprende cómo se llaman y memorízalos",
    "flyoceans": "Ayuda a Nikola a llegar de un océano a otro, aprende cómo se llaman y memorízalos",
    "animalsheneggs": "¿Qué fue antes, el huevo o la gallina? Descubre el ciclo vital en esta granja",
    "animalssoundswhichone": "Identifica los sonidos de los animales y pulsa en el que lo ha emitido",
    "numberswheelfortune": "Falta un vagón en la noria ¿Sabrías decir el número que es?",
    "numbersmoneyclassify": "Mete cada moneda en la hucha que indique su valor",
    "numbershowmanyinbarn": "Cuenta los animales que están entrando en el granero",
    "numbersalgebroid": "Guía el resultado de la pelota hasta los bloques con su operación hasta que no quede ninguno",
    "coloroid": "Guía a la pelota a los bloques del color que corresponde hasta que no quede ninguno",
    "rightleftdeliverycolors": "Mueve el barco al lado del color que corresponde",
    "numberspotions": "Coloca los objetos en el caldero para crear una poción mágica",
    "foodcook": "Arrastra los alimentos a la parrilla para cocinarlos, aprender sus nombres y darle la merienda a Jane",
    "bodyshower": "Ayuda a Alan a aprender a asearse el cuerpo paso a paso",
    "bodyfacewash": "Ayuda a Alan a aprender a asearse la cara paso a paso",
    "christmasmusichero": "Sigue los pasos del piano para aprender a tocar estas canciones navideñas",
    "racingcolors": "Colores",
    "christmasdecoratetree": "Decora el árbol de navidad para dejarlo a tu gusto",
    "pillchest": "Colores",
    "christmascoloring": "Pinta estos dibujos navideños de la manera que más te guste.",
    "christmasmemory": "Dale la vuelta a las cartas navideñas y memoriza su posición para hacer parejas",
    "covidgame": "Colores",
    "ramonelcamaleon": "Ayuda en este cuento a Ramón, el camaleón que cambia de color con cada emoción",
    "discoverycolors": "Gira las cartas para aprender a identificar los colores y sus nombres",
    "memory": "Gira las cartas para aprender a identificar los colores y sus nombres",
    "miceandcoding": "Planifica el recorrido que debe hacer el ratón para llegar hasta el queso ¡Cuidado con el gato!",
    "drawthepath": "Dibuja una línea que ayude a la pelota a llegar hasta Wolfie",
    "tangram": "Encaja las piezas de Lego en el tablero hasta que esté todo completo",
    "zamburguesas": "Con un amigo, colaborad para que cada uno de los personajes llegue a la barca",
    "pizzafor2": "Coopera con un compañero para hacer el máximo de pizzas posible antes de que se acabe el tiempo",
    "hideandseek": "Entre dos, jugad a esconder el dispositivo móvil en la vida real, siguiendo las instrucciones",
    "whichage": "¿Sabrías decir quién en más mayor? ¿Y quién es más joven?",
    "letterjigsawsliderjobs": "Coloca bien las piezas para descubrir las profesiones y su nombre",
    "whichemotion": "Pulsa en la emoción que se corresponda con la imagen",
    "letterjigsawsliderdinos": "Coloca bien las piezas para descubrir los dinosaurios y su nombre",
    "monsterparts": "Cuenta las partes de los monstruos y pulsa la respuesta correcta",
    "thesenses": "Aprende los sentidos y cómo los utilizamos",
    "aboutschool": "Pulsa en los elementos del la escuela correctos para aprender cómo se llaman",
    "halloweenbingo": "Escoge la decoración de Halloween que se te pide hasta conseguir líneas",
    "letterjigsawsliderfood": "Coloca bien las piezas para descubrir los alimentos y su nombre",
    "letterjigsawsliderinsects": "Coloca bien las piezas para descubrir los insectos y su nombre",
    "lettersjigsawslidervehicles": "Coloca bien las piezas para descubrir los vehículos y su nombre",
    "lettersjigsawslidermarineanimals": "Coloca bien las piezas para descubrir los animales marinos y su nombre",
    "christmasbingo": "Pulsa los objetos navideños que se te piden para hacer líneas",
    "lettersjigsawchristmas": "Coloca bien las piezas para descubrir los objetos navideños y su nombre",
    "lettersmessvowels": "Arrastra en la pantalla para encontrar e identificar las vocales minúsculas y mayúsculas que están flotando",
    "emotionsinarow": "Reconoce las emociones y colócalas en el lugar correcto para completar líneas",
    "wedraw": "Dibuja libremente el tema que te toque y luego observa cómo han dibujado otros el mismo tema",
    "whereisthis": "Busca y encuentra objetos y personajes entre la multitud ",
    "coloringpixelvowels": "Colorea los dibujos de pixel con el color que indican las vocales",
    "wordworm": "Haz que el gusanito se coma las letras para aprender el abecedario y formar palabras",
    "letterssorthome": "Ordena las letras para formar palabras que podemos encontrar en casa",
    "letterssortanimals": "Ordena las letras para formar los nombres de los animales",
    "letterssortcity": "Ordena las letras para formar los nombres de los elementos que puedes encontrar en la ciudad",
    "insectsbingo": "Selecciona los insectos que te pidan hasta conseguir líneas",
    "emotionsbingo": "Selecciona las emociones que te pidan hasta conseguir líneas",
    "marinebingo": "Selecciona los animales marinos que te piden hasta conseguir líneas",
    "jobsbingo": "Selecciona las profesiones que te piden hasta conseguir líneas",
    "lettersmissinghome": "Arrastra la letra que falta para completar la palabra con temática del hogar",
    "easterbingo": "Selecciona los elementos de las pascuas que te piden hasta conseguir líneas",
    "springbingo": "Selecciona los elementos primaverales que te piden hasta conseguir líneas",
    "lettersjigsawsliderspring": "Coloca bien las piezas para descubrir los objetos primaverales",
    "lettersmissinginsects": "Arrastra la letra que falta para completar el nombre de los insectos",
    "lettersmissingfood": "Arrastra la letra que falta para completar el nombre de la comida",
    "lettersmissingsports": "Arrastra la letra que falta para completar el nombre de los deportes",
    "cutwords": "Separa las palabras, cortando el papel,  para formas frases",
    "quijotebingo": "Selecciona los elementos relacionados con la lectura que te piden hasta conseguir líneas",
    "theabc": "Aprende el abecedario pulsando en la respuesta correcta",
    "realfooder": "Identifica la fotografía de los alimentos con su dibujo",
    "howmany": "Asociar número a cantidad del 1 al 5",
    "guesswho": "Pulsa en el personaje correcto según sus rasgos",
    "emotionmatch": "Identifica la emoción en imagen real con su representación en dibujo",
    "fairytales": "Quizz sobre cuentos infantiles",
    "animalshadow": "Selecciona la sombra del animal con el animal correspondiente",
    "wordsearchanimals": "Encuentra en esta sopa de letras los nombres de animales que se esconden en el tablero",
    "lettersskymap": "Traza y descubre las letras del abecedario. Mueve el dispositivo o arrastra en la pantalla para encontrar las constelaciones",
    "tapthefish": "Las burbujas te indican dónde va a aparecer el pez ¡Atrápalo! Luego cuenta los que has conseguido.",
    "wordsearchjobs": "Encuentra en esta sopa de letras el vocabulario de profesiones que se esconden en el tablero.",
    "pooptime": "¡Los Kokoros se están haciendo caca! Ayúdales con su rutina antes de que se acabe el tiempo.",
    "unboxing": "Coloca los objetos donde corresponda en las distintas habitaciones de la casa",
    "emotionssudoku": "Coloca las emociones sin que se repitan en la misma fila, la misma columna, o el mismo recuadro.",
    "talktowin": "Usa tu voz para darle ánimos al personaje y hacer que corra más rápido.",
    "wordsearchsummer": "Encuentra en esta sopa de letras el vocabulario de verano que se esconde en el tablero.",
    "summerinarow": "Reconoce los elementos veraniegos y colócalos en el lugar correcto para completar líneas.",
    "sportsinarow": "Reconoce los elementos deportivos y colócalos en el lugar correcto para completar líneas.",
    "wordsearchfood": "Encuentra en esta sopa de letras los nombres de comida que se esconden en el tablero.",
    "organizethesentence": "Ordena las palabras para formar frases que tengan sentido.",
    "coloringpixelconsonantsone": "Colorea los dibujos de pixel con el color que indican las consonantes.",
    "wedrawhalloween": "Dibuja la otra mitad del elemento de Halloween y mira lo que han creado otros",
    "additionsmess": "Arrastra la pantalla para encontrar y sumar los números que están flotando hasta alcanzar el resultado indicado",
    "numbersmess": "Arrastra la pantalla para encontrar e identificar los números que están flotando",
    "techinarow": "Reconoce los objetos tecnológicos y colócalos en el lugar correcto para completar líneas",
    "veggiesinarow": "Reconoce los alimentos vegetales y colócalos en el lugar correcto para completar líneas",
    "kokorocreator": "Crea tu propio personaje con características específicas y creatividad",
    "drawthepathwinter": "Ayuda al muñeco de nieve a recuperar su cabeza. Dibuja una línea para sostener su movimiento.",
    "rainbowbeehive": "Relájate cambiando de color la colmena y aprende lo importantes que son las abejas.",
    "imitateemotions": "Mueve las partes de la cara para recrear la emoción correcta.",
    "imitateemotionsmedium": "Mueve más partes de la cara para recrear la emoción correcta. En este nivel medio tendrás más elementos a modificar y expresiones realizadas por distintos personajes.",
    "imitateemotionshard": "Nivel experto emocional. Ahora mueve las partes de la cara para recrear la emoción correcta de la imagen real de referencia",
    "wedrawempathy": "Dibuja sobre tus amigos, familia y las que cosas que más te gustan y comparte con otros niños tus creaciones. Aprenderás sobre otras formas de ver el mundo.",
    "icecreamfor2": "Coopera con alguien para hacer el máximo de helados posible antes de que se acabe el tiempo",
    "whereisthisdog": "Busca y encuentra estos perritos entre la multitud",
    "whereisthiscat": "Busca y encuentra estos gatitos entre la multitud",
    "candychamaleon": "Ayuda al camaleón Caramelo a controlar sus impulsos y su respiración.",
    "drawyourpuzzleschool": "Dibuja con colores y pegatinas. Cuando termines tu dibujo se transformará en un puzle para resolver.",
    "eddiecolors": "Aprende con Eddie a diferenciar los colores, desde los más fáciles a los más complejos.",
    "winter_fairytales": "¿Cuánto sabes sobre cuentos de la temporada del invierno? Aprende curiosidades sobre cuentos.",
    "findindarkroomstrangethings": "Busca con la linterna las cosas extrañas de los años 80 que se te indican.",
    "marinelifecount": "Cuenta las patas, manchas y detalles de los animales marinos mientras exploras y conoces la fauna del fondo del mar.",
    "goodhabits": "Aprende vocabulario de hábitos de higiene y cuidado personal.",
    "wordchain": "Sigue la cadena de palabras. Elige la palabra que empieza con la última sílaba de la palabra anterior y completa la cadena.",
    "masterofsyllables": "Identifica cuantas sílabas tiene cada palabra para mejorar la lectura, escritura y pronunciación.",
    "thatistheduck": "Observa atentamente a los patos y encuentra el que cumple con la característica indicada. Puede ser un color, un accesorio o un disfraz específico. ¡Presta atención a los detalles y elige el pato correcto!",
    "vintagetech": "¿Cómo llamaban antes por teléfono? ¿Cómo se escribían mensajes a distancia? Aprende sobre tecnología antigua.",
    "thebigchain": "Aprende sobre las cadenas tróficas, y cuales son los organismos productores, consumidores y descomponedores en la naturaleza.",
    "discoverrobots": "Aprende qué son los robots y con cuáles te puedes encontrar en tu día a día",
    "findtheoddemotion": "Tu misión es encontrar la emoción que NO es igual a las demás. ¿Podrás encontrar todas?",
    "organizerubbish": "Clasifica el producto en su contenedor de reciclaje correspondiente",
    "mesozoicera": "Aprende sobre dinosaurios e identifica lo que sí y lo que no convivió con ellos.",
    "clothingfitsyou": "Identifica correctamente cada prenda de vestir en las partes del cuerpo y desarrolla la conciencia corporal.",
    "shapesoflife": "Observa objetos de la vida cotidiana e identifica su forma geométrica",
    "intrudersearch": "Los jugadores deben encontrar cuál de los objetos no encaja con los demás.",
    "treasurehunt": "Identifica todos los insectos, árboles y flores.",
    "numberscomp": "Averigua qué números son mayores o menores.",
    "whichjob": "Adivina la profesión"
  },
  "categories": {
    "emotions": "Socioemocional",
    "brain_games": "Habilidades Cognitivas",
    "numbers": "Lógico-matemática",
    "communication": "Competencia Lingüística",
    "creativity": "Creatividad",
    "science_nature": "Ciencias"
  },
  "subcategories": {
    "literacy": "Lectoescritura",
    "vocabulary": "Vocabulario",
    "grammar": "Gramática",
    "communication": "Comunicación",
    "attention": "Atención",
    "executive_functions": "Funciones Ejecutivas",
    "preception": "Percepción",
    "orientation": "Orientación",
    "problem_solving": "Resolución de problemas",
    "emotional_awareness": "Conciencia Emocional",
    "personal_autonomy": "Autonomía Personal",
    "social_competence": "Competencia Social",
    "emotional_regulation": "Regulación Emocional",
    "number_sense": "Sentido numérico",
    "operations": "Operaciones",
    "measures": "Medidas",
    "geometry": "Geometría",
    "logic": "Lógica",
    "environment": "Medio ambiente",
    "fauna": "Fauna",
    "human_being": "Ser humano",
    "food": "Alimentación",
    "natural_events": "Fenómenos naturales",
    "universe": "Universo",
    "living_in_society": "Vivir en sociedad",
    "technology": "Tecnología",
    "history": "Historia",
    "visual_arts": "Artes visuales",
    "music": "Música",
    "perception": "Percepción"
  },
  "objectives": {
    "history": "Historia",
    "fears": "Miedos",
    "language": "Idioma",
    "letter_discrimination": "Discriminación de letras",
    "spelling": "Deletreo",
    "graphomotricity": "Grafomotricidad",
    "compose_words": "Componer palabras",
    "reading": "Lectura",
    "animals": "Animales",
    "food": "Alimentos",
    "colors": "Colores",
    "sports": "Deportes",
    "technology": "Tecnología",
    "hobbies": "Aficiones",
    "transport_means": "Medios de transporte",
    "immediate_surroundings": "Entorno cercano",
    "body_parts": "Partes del cuerpo",
    "professions": "Profesiones",
    "clothing": "Prendas de vestir",
    "festivities": "Festividades",
    "semantic_association": "Asocación semántica",
    "sentences_forming": "Formar oraciones",
    "grammar_knowledge": "Conocimiento gramatical",
    "orthography": "Ortografía",
    "oral_expression": "Expresión oral",
    "oral_compression": "Comprensión oral",
    "phonological_knowledge": "Conciencia fonológica",
    "sustained_attention": "Atención Sostenida",
    "focused_attention": "Atención Focalizada",
    "divided_attention": "Atención Dividida",
    "alternating_attention": "Atención Alternante",
    "selective_attention": "Atención Selectiva",
    "work_memory": "Memoria de trabajo",
    "cognitive_flexibility": "Flexibilidad cognitiva",
    "anticipation": "Anticipación",
    "reasoning": "Razonamiento",
    "response_sepped": "Velocidad de respuesta",
    "planning": "Planificación",
    "inhibitory_control": "Control inhibitorio",
    "visual_perception": "Percepción Visual",
    "auditory_perception": "Percepción Auditiva",
    "visual_discrimination": "Discriminación visual",
    "spatial_orientation": "Orientación espacial",
    "personal_orientation": "Orientación personal",
    "temporary_orientation": "Orientación temporal",
    "compare": "Comparación",
    "association": "Asociación",
    "classification": "Clasificación",
    "emotions_recognition": "Reconocimiento de emociones",
    "self_knowledge": "Autoconocimiento",
    "emotions_expression": "Expresión de emociones",
    "self_confident": "Autoestima",
    "life_skills": "Habilidades para la vida",
    "routines": "Rutinas",
    "financial_independence": "Autonomía financiera",
    "security": "Seguridad",
    "motor_skills_development": "Desarrollo de habilidades motoras",
    "social_standards": "Normas sociales",
    "civic_values": "Valores cívicos",
    "social_skills": "Habilidades sociales",
    "cultural_diversity": "Diversidad cultural",
    "conflicts_solving": "Resolución de conflictos",
    "cooperation": "Cooperación",
    "mind_theory": "Teoría de la mente",
    "frustration_tolerance": "Tolerancia a la frustración",
    "behaviour_regulation": "Regulación de conducta",
    "relax": "Relajación",
    "impulsivity_work": "Trabajo de impulsividad",
    "fear_management": "Gestión de miedos",
    "numerical_representation": "Representación numérica",
    "counting": "Conteo",
    "numerical_correlation": "Correspondecia numérica",
    "portions": "Fracciones",
    "sums": "Sumas",
    "substracts": "Restas",
    "multiplications": "Multiplicaciones",
    "divisions": "Divisiones",
    "size": "Tamaño",
    "length": "Longitud",
    "weight": "Peso",
    "time": "Tiempo",
    "money": "Dinero",
    "geometric_shapes": "Figuras geométricas",
    "symmetries": "Simétrias",
    "straight_lines_types": "Tipos de rectas",
    "sequence": "Secuencias",
    "patterns": "Patrones",
    "serialisation": "Seriación",
    "computational_thinking": "Pensamiento computacional",
    "recycling": "Reciclaje",
    "landscape": "Paisaje",
    "vegetation": "Vegetación",
    "animal_kingdom": "Reino animal",
    "life_functions": "Funciones vitales",
    "habitat": "Hábitat",
    "dinasours": "Dinosaurios",
    "human_body": "Cuerpo humano",
    "physical_characteristics": "Rasgos físicos",
    "senses": "Los sentidos",
    "food_types": "Tipos de alimentos",
    "healthy_food": "Alimentación saludable",
    "weather": "El clima",
    "year_season": "Estaciones del año",
    "planets": "Planetas",
    "spacial_bodies": "Cuerpos espaciales",
    "earth": "La Tierra",
    "moon": "La Luna",
    "home": "El hogar",
    "school": "Colegio",
    "traditions": "Costumbres y tradiciones",
    "experiments": "Experimentos",
    "machines": "Máquinas",
    "programming": "Programación",
    "robotics": "Robótica",
    "civilizations": "Civilizaciones",
    "historical_characters": "Personajes históricos",
    "technique": "Técnica",
    "drawing": "Dibujo",
    "use_of_materials": "Uso de materiales",
    "creativity_expression": "Expresión creativa",
    "colors_discrimination": "Discriminación de colores",
    "decoration": "Decoración",
    "rhythm": "Ritmo",
    "melody": "Melodía",
    "music_styles": "Estilos musicales",
    "instruments": "Instrumentos",
    "year_seasons": "Estaciones del año",
    "response_speed": "Velocidad de respuesta",
    "dinosaurs": "Dinosaurios",
    "subtracts": "Restas",
    "decision_making": "Toma de decisiones",
    "categorization": "Categorización",
    "selectedCount": "{count} seleccionados"
  },
  "faqs_categories": {
    "first_steps": "Cuenta",
    "account": "Perfil de usuario",
    "creating_customized_sessions": "Creación de sesiones personalizadas",
    "content_and_games": "Contenido y juegos",
    "plans": "Planes",
    "accessibility_and_inclusion": "Accesibilidad e inclusión",
    "resources_and_training": "Recursos y formación",
    "technical_support": "Soporte técnico"
  },
  "faqs_subcategories": {
    "first_question": "Ya soy usuario de Kids, ¿tengo que registrarme de nuevo?",
    "first_text": "",
    "second_question": "¿Puedo usar Kokoro Schools si no trabajo en un colegio?",
    "second_text": "¡Sí! Aunque Kokoro Schools está diseñado principalmente para entornos escolares, también es útil fuera de los colegios. Si trabajas en un contexto educativo alternativo, como apoyo a domicilio, terapias educativas, centros de refuerzo escolar, o incluso como padre o tutor que quiera mejorar el desarrollo de un niño, Kokoro Schools puede ayudarte de varias maneras, descúbrelo en este <a href=‘https://link.apolokids.com/DNG3Fv’ target=‘_blank’>post de nuestro blog</a>\n",
    "third_question": "Soy psicólogo/a, ¿cómo me ayuda Kokoro Schools en mi trabajo diario?",
    "third_text": "Como psicólogo/a, Kokoro Schools te ofrece la posibilidad de integrar el juego en la terapia para trabajar diversas áreas del desarrollo emocional y cognitivo de los niños. Algunos de los usos prácticos en terapia son la evaluación y seguimiento, la personalización de las actividades terapéuticas o la regulación de las emociones. En este <a href=‘https://link.apolokids.com/dAOVvz’ target=‘_blank’>post</a> te explicamos como introducir Kokoro Schools en terapia y los beneficios del juego.",
    "fourth_question": "Soy profesor/a, ¿cómo me beneficia Kokoro Schools en el aula?",
    "fourth_text": "Como profesor o profesora, Kokoro Schools no solo te ayuda a gestionar el aprendizaje individualizado y personalizado, sino que también puede combinarse con otras metodologías innovadoras y tradicionales en el aula para potenciar aún más la enseñanza. <a href=‘https://link.apolokids.com/5dx7q9’ target=‘_blank’>Aquí te explicamos cómo</a>",
    "fifth_question": "¿Kokoro Schools es útil si no soy psicólogo/a ni profesor/a?",
    "fifth_text": "Sí, Kokoro Schools puede ser una herramienta valiosa incluso si no eres psicólogo/a ni profesor/a. Diseñado para apoyar el aprendizaje y el desarrollo infantil, la plataforma es útil para padres y madres, tutores, monitores de actividades, investigadores y profesionales de la tecnología educativa. Gracias a sus opciones de personalización y su enfoque en la atención a la diversidad, permite adaptar los contenidos a diferentes necesidades y contextos. <a href=‘https://apolokids.com/kokoro-schools-para-psicologos-como-integrarlo-en-terapia/’ target=‘_blank’>Descubre cómo utilizar Kokoro Schools en este artículo. </a>",
    "sixth_question": "¿Para qué perfiles de niños/as está recomendado?",
    "sixth_text": "Kokoro Schools está recomendado para todos los niños y niñas, ya que se adapta a diferentes ritmos y niveles de aprendizaje, lo que lo hace ideal tanto para niños neurotípicos como para aquellos con necesidades específicas de apoyo educativo (NEAE). La plataforma es inclusiva, ajustándose a las necesidades individuales de cada niño, promoviendo un aprendizaje personalizado y respetuoso con su proceso de desarrollo.</br>\nEs especialmente útil para niños con TDAH y TEA, ya que ofrece opciones para regular los estímulos visuales y auditivos, evitando la sobrecarga sensorial. Los juegos adaptativos permiten que los niños avancen a su propio ritmo, favoreciendo un ambiente de aprendizaje más positivo y sin presiones​.</br>\nEl enfoque en áreas clave como el desarrollo socioemocional, la creatividad, la competencia lingüística y las habilidades lógico-matemáticas hace que sea adecuado para niños en diversas etapas educativas, desde la educación infantil hasta la primaria, contribuyendo al desarrollo integral de habilidades esenciales​.</br>",
    "seventh_question": "¿Cómo puedo solicitar una demo para mi centro educativo?",
    "seventh_text": "Para solicitar una demo de Kokoro Schools para tu centro educativo, puedes escribirnos a nuestro correo de contacto. Uno de nuestros asesores te hará una demo y resolverá todas las dudas que puedas tener sobre cómo aprovechar al máximo la plataforma en tu centro.",
    "eighth_question": "¿Existen centros que ya están usando Kokoro Schools?",
    "eighth_text": "Sí, actualmente tenemos centros educativos en distintas partes del mundo como España, Perú o Abu Dhabi usando Kokoro Schools para mejorar la experiencia de aprendizaje de sus estudiantes. </br>\n\nEstos centros están implementando Kokoro Schools para personalizar el aprendizaje, mejorar las habilidades socioemocionales y apoyar a los alumnos con necesidades educativas especiales.</br>",
    "ninth_question": "Tengo un problema, ¿cómo puedo contactar con vosotros?",
    "ninth_text": "",
    "tenth_question": "¿Qué beneficios ofrece Kokoro Schools a los niños/as?",
    "tenth_text": "Kokoro Schools ofrece múltiples beneficios para los niños, centrándose en su <b>desarrollo integral a través de la personalización y el juego adaptativo</b>. Al permitir a los profesionales crear experiencias ajustadas a las necesidades individuales, los niños pueden avanzar a su propio ritmo y recibir apoyo específico en áreas que requieren mayor refuerzo, como las habilidades lógico-matemáticas, la competencia lingüística, o el desarrollo socioemocional. Esta adaptación del aprendizaje es especialmente beneficiosa para aquellos niños con  <b>necesidades específicas de apoyo educativo (NEAE)</b>, como dificultades de aprendizaje, específicas del lenguaje o la dislexia, ya que la plataforma se ajusta para mejorar la comprensión y retención de conceptos clave.</br>\n\nEl enfoque basado en el juego también impulsa el bienestar socioemocional, brindando a los niños un espacio donde se sienten seguros para explorar y expresarse. Los  <b>juegos cooperativos y de aprendizaje social</b> ayudan a fomentar la empatía, la comunicación y el trabajo en equipo, habilidades esenciales para el desarrollo emocional. Además, la posibilidad de <b>regular estímulos y limitar el tiempo </b>de uso garantiza un entorno seguro, permitiendo a los niños concentrarse y evitar la sobreestimulación.</br>\n\nCon la inclusión de una amplia variedad de contenidos y actividades, Kokoro Schools busca no solo apoyar el aprendizaje académico, sino también fortalecer la autonomía, autoestima y creatividad en los niños, preparándolos de forma equilibrada para los retos futuros.</br>",
    "eleventh_question": "¿Cuántos niños o perfiles puedo crear?",
    "eleventh_text": "Depende del tipo de plan que tengas activo. Si estás utilizando nuestra versión gratuita y ya no disfrutas del periodo de prueba, sólo podrás crear/utilizar uno de los perfiles de alumno.</br> <br>Sin embargo, si disfrutas de la suscripción para profesionales podrás crear y utilizar hasta 3 perfiles. Con nuestro plan más completo, el plan para colegios, el número de perfiles es ilimitado.</br>",
    "twelfth_question": "¿En qué idiomas pueden jugar?",
    "twelfth_text": "Pueden jugar en cuatro idiomas diferentes: español (España), inglés (EEUU), portugués (Brasil) y bahasa (Indonesia) (más idiomas próximamente)</br>\n\nUtilizar nuestras actividades en un idioma diferente al idioma nativo de ese alumno, es una manera diferente de utilizar nuestros recursos, ya que puede iniciarle en el aprendizaje del idioma escogido.</br>",
    "thirteenth_question": "¿Qué áreas de desarrollo puedo trabajar con los niños/as?",
    "thirteenth_text": "Podrás trabajar múltiples áreas clave para el desarrollo de los niños, enfocándote en su crecimiento académico, cognitivo y socioemocional. La plataforma permite reforzar habilidades lógico-matemáticas mediante juegos que desarrollan la resolución de problemas y el pensamiento crítico, además de trabajar la competencia lingüística a través de actividades que mejoran el vocabulario, la expresión oral y la comprensión lectora.</br>\n\nAsimismo, puedes impulsar el desarrollo socioemocional, proporcionando un espacio seguro para aprender a reconocer y gestionar sus emociones, fortalecer su autoestima y trabajar en la empatía y colaboración mediante juegos cooperativos. Las habilidades cognitivas, como la memoria, la atención y el procesamiento visual, son también áreas de enfoque, asegurando que cada niño avance según su propio ritmo y capacidades.</br>\n\nAdemás, Kokoro Schools incluye contenidos y actividades que estimulan la creatividad y la curiosidad científica, ayudando a los niños a explorar conceptos de ciencia y tecnología de una manera dinámica. Todo esto se realiza en un entorno inclusivo y seguro, adaptado a las necesidades individuales, lo cual facilita una experiencia de aprendizaje completa y personalizada.</br>",
    "fourteenth_question": "¿En qué dispositivos puedo utilizar Kokoro Schools?",
    "fourteenth_text": "Kokoro Schools puede utilizarse desde cualquier dispositivo y cualquier sistema operativo, además, no necesita instalación ya que es una web interactiva \n¡Puedes crear tus sesiones educativas estés donde estés!</br>\n\nSin embargo, para que tus alumnos puedan acceder a las actividades de tus sesiones educativas, necesitarán un dispositivo móvil (smartphone o tablet) con la aplicación Kokoro Kids instalada e iniciada con tu usuario, así ellos también podrán acceder a las sesiones que tú has preparado, estén donde estén.</br>\n\nLa aplicación Kokoro Kids puede descargarse en App Store o Google Play.</br>",
    "fifteenth_question": "Me gustaría indicaros una mejora, ¿cómo puedo contactar con vosotros?",
    "fifteenth_text": "Puedes mandarnos un mensaje a nuestro correo y nuestro equipo de pedagogía se pondrá en contacto contigo.",
    "sixteenth_question": "¿Kokoro Schools puede crear sesiones personalizadas para mis alumnos?",
    "sixteenth_text": "",
    "seventeenth_question": "¿Está adaptado? o ¿cuál es el grado de adaptación al que llega?",
    "seventeenth_text": "Sí, los juegos de Kokoro están diseñados para adaptarse al nivel de cada niño a medida que avanza. Utilizamos un <b>sistema de nivelación progresiva </b> que ajusta la dificultad según el rendimiento del jugador, permitiendo un aprendizaje a su propio ritmo. Además, cada juego trabaja diferentes habilidades con enfoques variados, ofreciendo desafíos adecuados sin generar frustración. Esta adaptación garantiza que todos los niños, independientemente de su punto de partida, puedan disfrutar y beneficiarse del aprendizaje basado en el juego.",
    "eighteenth_question": "¿Para qué edades está recomendado?",
    "eighteenth_text": "Está recomendado para niños de <b>más de 3 años</b>, ya que abarca desde la etapa de <b>educación infantil hasta la educación primaria.</b> Los juegos están diseñados para adaptarse a las distintas fases de desarrollo cognitivo, emocional y social de los niños en este rango de edad.</br>\nLa plataforma se adapta tanto a los más pequeños, que están en las primeras etapas del desarrollo, como a los niños mayores, ya que los niveles de los juegos se ajustan al ritmo y nivel de cada uno. Esto permite que sea eficaz tanto para niños que están empezando a desarrollar sus habilidades básicas, como el lenguaje y la lógica, como para aquellos que están avanzando en áreas más complejas, como las matemáticas o las ciencias​.</br>\nAdemás, es particularmente útil para niños con <b>necesidades específicas de apoyo educativo (NEAE)</b>, ya que ofrece funcionalidades inclusivas como la regulación de estímulos y la personalización de las actividades en función de sus necesidades individuales</br>",
    "nineteenth_question": "¿En qué consiste la personalización? ¿Qué elementos se adaptan?",
    "nineteenth_text": "Kokoro Schools es una herramienta que permite la personalización en dos aspectos. Por un lado, <b> personalizar los perfiles individuales </b>, seleccionando el idioma, el tiempo limite de juego, y regulando las funcionalidades de acceso como estímulos visuales y auditivos. Por otro lado, te permite <b> personalizar las sesiones de juego </b>, seleccionando los contenidos y los juegos específicos para cada perfil.",
    "twentieth_question": "¿Cómo funciona el periodo de prueba?",
    "twentieth_text": "El periodo de prueba tiene una <b>duración de 15 días </b> desde que accedes por primera vez a Kokoro Schools. Durante este tiempo puedes acceder a todas las funcionalidades que te ofrecemos, creando perfiles y sesiones ilimitadas. </br>\nPasados estos 15 días tu plan pasará a estar limitado al uso de un solo perfil y creación de 3 sesiones educativas mensuales. Puedes volver a tener acceso completo en cualquier momento suscribiéndote a alguno de nuestros planes. </br>",
    "twenty_first_question": "¿Hay versión gratuita?",
    "twenty_first_text": "Sí, es nuestro plan básico. Este plan está limitado al <b> uso de un solo perfil y a la creación de 3 sesiones educativas mensuales </b>. Puedes tener acceso completo en cualquier momento suscribiéndote a alguno de nuestros planes.",
    "twenty_second_question": "¿Qué ocurre cuando acaba el período de prueba?",
    "twenty_second_text": "Pasados los 15 días del periodo de prueba, si no te has suscrito a ninguno de los planes, se bloquearán todos los perfiles que hayas creado, excepto el primero, que podrás usar indefinidamente en nuestra versión gratuita.\nCon esta versión gratuita sólo podrás crear 3 sesiones educativas al mes para ese mismo perfil. </br>\n\nPuedes volver a tener acceso completo en cualquier momento suscribiéndote a alguno de nuestros planes.</br>",
    "twenty_third_question": "¿Cuál es el precio de Kokoro Schools una vez finalizado el período de prueba?",
    "twenty_third_text": "",
    "twenty_fourth_question": "Quiero volver a la experiencia que tenía con Kokoro Kids, ¿cómo puedo hacerlo?",
    "twenty_fourth_text": "",
    "twenty_fifth_question": "¿Cómo empiezo a crear una sesión personalizada para un niño/a?",
    "twenty_fifth_text": "Haz click en la tarjeta del alumno en la página de inicio, accederás al perfil del niño y allí encontrarás el botón <b> \"Crear sesión\" </b>(si no tiene ninguna sesión creada, o la sesión anterior ya ha sido jugada varias veces, podrás acceder a este botón directamente desde la tarjeta del alumno). </br>\nAparecerá desplegada la creación de sesiones, en ella podrás elegir dos maneras de crear esa sesión:</br>\n\n<b> 1. Sesión recomendada: </b> Son sesiones predefinidas agrupadas por contenidos y seleccionadas por nuestros profesionales. Es la manera más rápida de crear sesiones ya que pulsando una de ellas, la enviarás directamente a Kokoro Kids para que tu alumno la pueda trabajar.</br>\n\n <b> 2. Explorando todos los juegos:</b> Para crear una sesión de juegos 100% de tu elección, esta es la mejor manera. podrás filtrar los contenidos dependiendo de lo que quieras trabajar en esa sesión. A medida que escojas contenidos, aparecerán juegos relacionados con ellos. <b> Podrás probarlos o directamente seleccionarlos</b> para que se añadan al carrito de la sesión. Cuando hayas escogido todos los juegos que quieres que formen parte de la sesión, en el carrito encontrarás el botón \"Crear sesión\" con el que ya podrás enviarla a Kokoro Kids para que el alumno la trabaje.</br>",
    "twenty_sixth_question": "¿Qué contenidos puedo seleccionar para cada niño/a?",
    "twenty_sixth_text": "",
    "twenty_seventh_question": "¿Cómo son los contenidos de Kokoro Schools?",
    "twenty_seventh_text": "",
    "twenty_eighth_question": "Quiero limitar el tiempo de juego de un niño, ¿cómo puedo hacerlo?",
    "twenty_eighth_text": "Puedes hacerlo desde el perfil del niño (pulsando en la tarjeta del alumno) editando su perfil, o desde el carrito mientras estás creando una sesión para ese niño, en el botón de configuración. </br>\n\nDentro de los ajustes de accesibilidad, en la parte de abajo de la edición del perfil, verás la opción de añadir un límite de tiempo de juego. Actívalo y escoge la cantidad de minutos que quieres que el niño pueda estar trabajando esa sesión (5, 10, 20...).</br>",
    "twenty_ninth_question": "Quiero reducir los estímulos visuales de los juegos para un niño, ¿cómo puedo hacerlo?",
    "twenty_ninth_text": "Puedes hacerlo desde el perfil del niño (pulsando en la tarjeta del alumno) editando su perfil, o desde el carrito mientras estás creando una sesión para ese niño, en el botón de configuración.</br>\n\nDentro de los ajustes de accesibilidad, en la parte de abajo de la edición del perfil, verás la opción de reducir el volumen de la voz en off de la aplicación Kokoro Kids y la de reducir el volumen de la música y efectos de sonido. Para desactivarlos completamente, simplemente lleva el selector hasta el cero.</br>\nTen en cuenta que la voz no desaparecerá del todo ya que es necesaria para las instrucciones de algunos de los juegos.</br>",
    "thirtieth_question": "Quiero inhabilitar los sonidos de los juegos para un niño, ¿cómo puedo hacerlo?",
    "thirtieth_text": "",
    "thirty_first_question": "¿Cuánto tiempo se tarda en crear una sesión personalizada?",
    "thirty_first_text": "",
    "thirty_second_question": "¿Se puede introducir un grupo entero a la vez?",
    "thirty_second_text": "",
    "thirty_third_question": "¿Puedo tener varios grupos?",
    "thirty_third_text": "",
    "thirty_fourth_question": "¿Puedo ver las sesiones de todo un grupo a la vez?",
    "thirty_fourth_text": "",
    "thirty_fifth_question": "¿Por qué crear una sesión de juegos?",
    "thirty_fifth_text": "El juego es una herramienta pedagógica poderosa que complementa la enseñanza en el aula. Crear una sesión de juegos permite introducir conceptos nuevos de manera dinámica, reforzar aprendizajes previos y evaluar conocimientos de forma lúdica. Además, favorece la motivación, la atención y el aprendizaje activo, adaptándose al ritmo de cada niño. Usar el juego en el aula es tan válido como emplear un libro, una película o cualquier otro recurso educativo.",
    "thirty_sixth_question": "¿Qué es una sesión de juegos y cómo se crea?",
    "thirty_sixth_text": "Es una selección estructurada de actividades interactivas que permiten trabajar objetivos educativos específicos. Funciona como cualquier otro recurso didáctico que un docente elige para su clase, pero con la ventaja de adaptarse al ritmo y nivel de cada niño. Para crearla, solo hay que <b>seleccionar los juegos adecuados </b>dentro de la plataforma según el contenido que se quiera trabajar y asignarlos a los niños y niñas, siguiendo la progresión de aprendizaje deseada.",
    "thirty_seventh_question": "¿Voy a poder ver y jugar a los juegos antes de elegirlos?",
    "thirty_seventh_text": "Sí. En la creación de sesiones verás el botón <b>\"Probar juegos\"</b> que estará siempre asociado a cada uno de ellos. Puedes probarlos tanto tiempo como quieras hasta que los cierres.\nTen en cuenta que estos juegos a través de esta visualicación, siempre empezarán por el nivel más bajo.",
    "thirty_eighth_question": "¿Cómo puedo ver los juegos asociados a cada contenido?",
    "thirty_eighth_text": "Dentro de la creación de sesiones, al <b>\"filtrar todos los juegos\"</b>, podrás ir seleccionando contenidos. A medida que los selecciones, irán apareciendo los juegos asociados a ellos, listos para ser seleccionados. </br> Pueden aparecer juegos cuyo objetivo principal no es el que tú has seleccionado, pero que sí trabajan ese contenido. Para ver qué contenido es el principal de cada juego, pulsa en el símbolo de información que verás en la esquina superior derecha de cada actividad.  El contenido principal es el que está marcado.</br>",
    "thirty_ninth_question": "¿Qué significa cada tipo de contenido en la plataforma?",
    "thirty_ninth_text": "Dentro de la plataforma, los juegos y actividades están organizados en distintas categorías según las habilidades que trabajan, como funciones ejecutivas, atención, percepción o socioemocionales. Para entender mejor cada tipo de contenido, puedes consultar nuestro glosario, donde se explican las áreas de desarrollo y su aplicación en el aprendizaje.",
    "forty_fourth_question": "¿Está alineado con la LOMLOE?",
    "forty_fourth_text": "Sí, la plataforma se ajusta a los principios de la LOMLOE al promover un aprendizaje basado en competencias, fomentando la personalización y la inclusión. </br> Nuestros juegos están diseñados para desarrollar habilidades transversales como la resolución de problemas, el pensamiento crítico y la gestión emocional, elementos clave en el enfoque competencial de la ley. </br> <br>Además, los juegos pueden usarse para trabajar diferentes ámbitos del currículo de manera lúdica y adaptada a las necesidades del alumnado.</br>",
    "forty_fifth_question": "¿Puedo incluir Kokoro en uns situación de aprendizaje?",
    "forty_fifth_text": "Incluir Kokoro en una situación de aprendizaje es sencillo y eficaz, ya que permite integrar recursos adaptados a los objetivos y las habilidades que quieres reforzar en tus alumnos.</br>\n\nPor ejemplo, en un proyecto sobre emociones en educación infantil, podrías añadir un juego de identificación emocional de Kokoro para que los alumnos practiquen cómo reconocer y expresar sentimientos. El juego podría ser una actividad de introducción o de cierre dentro de la sesión, facilitando una reflexión grupal sobre lo aprendido.</br>\n\nEn un proyecto de resolución de problemas matemáticos en primaria, podrías incluir un juego de secuencias lógicas o cálculo mental de la plataforma como actividad complementaria. Este juego reforzaría los conceptos tratados en clase de manera interactiva y personalizada según el nivel de cada alumno.</br>\n\nKokoro Schools puede usarse como recurso autónomo o como complemento en proyectos y actividades de aprendizaje. Su flexibilidad permite personalizar las actividades según el progreso y las necesidades individuales, lo cual facilita un aprendizaje dinámico y centrado en el alumno.</br>",
    "forty_sixth_question": "¿Añadís nuevo contenido?",
    "forty_sixth_text": "Sí, en Kokoro Schools <b>se añade contenido nuevo de manera regular.</b> Nuestro equipo de especialistas en pedagogía y desarrollo de videojuegos educativos trabaja continuamente para integrar nuevas actividades y mantener la plataforma actualizada, de modo que los profesionales dispongan siempre de recursos frescos y relevantes para sus sesiones.",
    "forty_seventh_question": "¿Cuánto contenido voy a poder añadir en una sesión?",
    "forty_seventh_text": "",
    "forty_eighth_question": "¿Cómo puedo ver qué contenido trabaja cada juego?",
    "forty_eighth_text": "En cada juego encontrarás un icono con la letra <b>\"i\" de información</b>. Al pulsarlo, se desplegará un menú con las habilidades y contenidos específicos que se trabajan en ese juego. Así podrás conocer de un vistazo qué aspectos pedagógicos se refuerzan y elegir los más adecuados según las necesidades de los niños y niñas.",
    "forty_ninth_question": "¿Cómo puedo añadir un juego a una sesión?",
    "forty_ninth_text": "",
    "fiftieth_question": "¿Cómo sé el nivel de cada juego?",
    "fiftieth_text": "",
    "fifty_first_question": "¿Es confiable el contenido de Kokoro Schools? ¿Está desarrollado por especialistas?",
    "fifty_first_text": "Sí, todo el contenido de Kokoro está desarrollado por un equipo multidisciplinar de especialistas en psicología, pedagogía y juego, diseño y desarrollo de videojuegos. Además, su eficacia está respaldada por investigaciones científicas en colaboración con la <b>Universidad Politécnica de Valencia (UPV) y la Universidad Jaume I (UJI)</b>, que avalan el uso de los juegos para desarrollar habilidades clave como el procesamiento visual, la memoria o la atención.",
    "fifty_second_question": "Quiero que el niño juegue, ¿qué debo hacer ahora?",
    "fifty_second_text": "Para que el niño juegue a la sesión que has preparado, debes tener instalada en un dispositivo móvil la <a href=‘https://kokorokids.go.link?adj_t=1l4i1na7’ target=‘_blank’> aplicación Kokoro Kids</a> (disponible en App Store y Google Play) y entrar en ella con la misma cuenta que tienes asociada a Kokoro Schools. </br>\nDentro de la aplicación de Kokoro Kids, el niño podrá entrar en su perfil y jugar a los juegos de tu sesión.</br>",
    "fifty_third_question": "Quiero añadir más juegos, ¿qué debo hacer?",
    "fifty_third_text": "",
    "fifty_fourth_question": "Quiero eliminar uno o varios juegos, ¿qué debo hacer?",
    "fifty_fourth_text": "",
    "fifty_fifth_question": "¿Puedo elegir el orden en el que va a jugar?",
    "fifty_fifth_text": "",
    "fifty_sixth_question": "¿Cuánto tiempo recomiendan para cada sesion?",
    "fifty_sixth_text": "Recomendamos sesiones de unos <b>20 minutos al día</b>, asegurando un uso equilibrado de las pantallas con contenido de calidad educativa. El tiempo invertido en Kokoro Schools no solo entretiene, sino que también potencia habilidades clave en los niños. </br> Además, los adultos pueden implicarse en el proceso de juego, ya sea jugando con ellos o siguiendo su progreso en el área de padres. La plataforma también permite regular el tiempo de juego según las preferencias de cada sesión.</br>",
    "fifty_seventh_question": "¿Cómo se organizan las sesiones en el dispositivo del niño?",
    "fifty_seventh_text": "",
    "fifty_eighth_question": "¿Tengo que crear una cuenta nueva cuando descargue la app Kokoro Kids?",
    "fifty_eighth_text": "No. Para poder acceder a las sesiones de juego que preparas a través de Kokoro Schools, debes entrar en Kokoro Kids con la misma cuenta con la que las has creado en Kokoro Schools.</br>\nCon la misma cuenta de google, el mismo Appl ID o el mismo correo y contraseña.</br>",
    "fifty_ninth_question": "Quiero ponerle un nombre a una sesión creada, ¿cómo puedo hacerlo?",
    "fifty_ninth_text": "Cuando termines de crear la sesión, verás los <b>pasos que tienes que seguir </b>después para que el niño la pueda jugar. El primero de esos pasos, que no es obligatorio seguir, es elegir un nombre de sesión. \nEstos nombres te ayudarán a recordar lo que ese niño ya ha estado trabajando.",
    "sixtieth_question": "¿Cómo puedo ver los juegos que he elegido?",
    "sixtieth_text": "",
    "sixty_first_question": "Quiero modificar una sesión activa ¿Cómo puedo hacerlo?",
    "sixty_first_text": "",
    "sixty_second_question": "Quiero ver el progreso/evolución del niño después de jugar a los juegos, ¿cómo puedo verlo?",
    "sixty_second_text": "",
    "sixty_third_question": "Quiero guardar la sesión para utilizarla varios días, ¿cómo puedo hacerlo?",
    "sixty_third_text": "",
    "sixty_fourth_question": "¿Puedo modificar parte del contenido de la sesión?",
    "sixty_fourth_text": "",
    "sixty_fifth_question": "¿Dónde se reflejan los cambios que he hecho en la configuración?",
    "sixty_fifth_text": "Lo verás reflejado en el uso de la aplicación Kokoro Kids, donde el niño trabaja las sesiones. También verás estos cambios guardados en la configuración del niño, tanto dentro de Kokoro Kids, como en Kokoro Schools.",
    "sixty_sixth_question": "¿Cómo se conecta Kokoro Schools con la Fundación LEGO y sus metodologías?",
    "sixty_sixth_text": "",
    "sixty_seventh_question": "¿Qué estudios y evidencia científica respaldan la efectividad de Kokoro Schools?",
    "sixty_seventh_text": "",
    "sixty_eighth_question": "¿Necesito formación para utilizar Kokoro Schools?",
    "sixty_eighth_text": "",
    "sixty_ninth_question": "¿En que consisten los cursos de formación impartidos por Auticmo?",
    "sixty_ninth_text": ""
  },
  "sessions": {
    "title_1": "Preescritura",
    "subtitle_1": "Fomenta las habilidades iniciales para la escritura en niños de 3 a 6 años, utilizando juegos que desarrollan la coordinación motriz fina, el trazo de formas, números y letras, y la creatividad. Ayuda a desarrollar una base sólida para la escritura.",
    "desc_1": "Competencia Lingüística; percepción; motricidad fina; atención; grafomotricidad; orientación espacial; creatividad;  habilidades sociales; simetrías; resolución de problemas; planificación.",
    "title_2": "Rutinas diarias",
    "subtitle_2": "Aprende a gestionar el día a día de forma autónoma. Adquiere herramientas para planificar y superar retos a partir de estrategias creativas. Esta sesión ayuda a familiarizarse y experimentar con actividades cotidianas.",
    "desc_2": "Socioemocional; coordinación, orientación; atención; higiene personal; planificación; seguimiento de instrucciones; secuenciación; lateralidad; direccionalidad.",
    "title_3": "Direccionalidad",
    "subtitle_3": "Entrena conceptos como arriba, abajo, izquierda y derecha, adelante y atrás, reforzando su orientación espacial y pensamiento lógico. Comprender la direccionalidad es clave para moverse con seguridad y precisión en el entorno.",
    "desc_3": "Habilidades cognitivas; lógica; ubicación; dirección; relaciones espaciales; distancia; movimiento; simetrías; posiciones; planificación; coordinación ojo-mano; orientación; lateralidad; codificación; anticipación.",
    "title_4": "Vocabulario emocional",
    "subtitle_4": "Explora las emociones. Aprende a identificar y nombrar lo que sientes, reconocer emociones en los demás y expresarlas de forma adecuada, ayudando así al desarrollo emocional y social.",
    "desc_4": "Habilidades socioemocionales; reconocimiento de emociones; vocabulario emocional; empatía;expresión emocional; regulación emocional; percepción; atención; lógica; asociación; patrones.",
    "title_5": "Formar palabras",
    "subtitle_5": "¿Cómo se escriben las palabras? Amplia el vocabulario sencillo de animales, deportes, instrumentos musicales, comida, transportes, estaciones y profesiones, a través de diferentes mecánicas. ",
    "desc_5": "Competencia lingüística; asociación grafema-morfema; conciencia fonológica, discriminación visual; memoria; ortografía básica; planificación; atención; percepción; deletreo; semántica.",
    "title_6": "Códigos y patrones",
    "subtitle_6": "Juegos que introducen el pensamiento computacional a través de la identificación de patrones, secuencias lógicas y reglas básicas de codificación. Explora la lógica detrás de los códigos y secuencias, la estructuración del pensamiento y la resolución de problemas.",
    "desc_6": "Habilidades cognitivas; lógico-matemática; patrones; pensamiento computacional, secuenciación; atención; planificación; programación básica; orientación espacial; resolución de problemas; memoria de trabajo",
    "title_7": "Dificultades en la atención",
    "subtitle_7": "Desarrolla la capacidad de concentración y reacción con juegos para entrenar diferentes tipos de atención: sostenida, dividida y selectiva. Encuentra objetos ocultos, responde rápido a estímulos y mantén el foco en desafíos visuales y auditivos.",
    "desc_7": "Habilidades cognitivas; Atención sostenida; atención dividida; atención selectiva; velocidad de procesamiento; percepción visual; discriminación de estímulos; memoria de trabajo; control inhibitorio; asociación; anticipación.",
    "title_8": "Retos de lógica",
    "subtitle_8": "Desafía tu mente con juegos que entrenan el pensamiento lógico, la resolución de problemas y la planificación. Resuelve puzles, encuentra patrones, dibuja caminos estratégicos y enfrenta retos que pondrán a prueba tu capacidad de deducción.",
    "desc_8": "Habilidades cognitivas; razonamiento; lógica; resolución de problemas; planificación; estrategia; asociación; categorización; patrones; orientación espacial; creatividad; toma de decisiones.",
    "title_9": "Descubre los números",
    "subtitle_9": "Aprende y refuerza los números del 0 al 10. Contar, ordenar, asociar cantidades y reconocer cifras se vuelve divertido con retos dinámicos que fomentan la comprensión numérica desde las primeras etapas.",
    "desc_9": "Lógico-matemática; reconocimiento numérico; conteo; secuencias numéricas; comparación; atención; percepción visual; memoria; grafomotricidad; clasificación; asociación, orientación espacial.",
    "title_10": "Mundo animal",
    "subtitle_10": "Explora el reino animal y descubre desde los habitantes del mar hasta el trabajo incansable de las abejas. Identifica especies, sus hábitats y lo que comen mientras resuelves retos de memoria, lógica y observación.",
    "desc_10": "Ciencias; naturaleza; clasificación y reconocimiento de animales; vocabulario; atención; memoria visual; asociación; motricidad fina; conciencia ecológica; lógica; relajación; orientación."
  },
  "common": {
    "back": "Volver",
    "continue": "Continuar",
    "close": "Cerrar",
    "done": "¡Hecho!",
    "attention": "Atención",
    "later": "Más tarde",
    "goBack": "Volver atrás",
    "save": "Guardar",
    "cancel": "Cancelar",
    "accept": "Aceptar",
    "applyChanges": "Aplicar cambios",
    "finish": "Terminar",
    "update": "Actualizar",
    "remove": "Eliminar",
    "new": "NUEVO",
    "or": "o",
    "month": "Mes",
    "year": "Año",
    "language": "Idioma",
    "chooseOption": "Escoge una opción",
    "chooseLanguage": "Escoge un idioma",
    "yes": "Sí",
    "no": "No",
    "notSure": "No lo sé",
    "preferNotToAnswer": "Prefiero no contestar",
    "daysCount": "{count} días",
    "days": "días",
    "minutesCount": "{count} minutos",
    "yearsCount": "{count} años",
    "search": "Buscar",
    "help": "Ayuda",
    "confirmGoBack": "¿Seguro que quieres ir atrás?",
    "years": "años"
  },
  "auth": {
    "noAccount": "¿Aún no tienes cuenta?",
    "alreadyHaveAccount": "Ya tengo cuenta",
    "alreadyHaveAccountQuestion": "¿Ya tienes cuenta?",
    "almostThere": "¡Ya casi está!",
    "sessionExpired": "Sesión expirada",
    "logout": "Cerrar sesión",
    "signupError": "Error al registrar un nuevo usuario",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "repeatPassword": "Repetir contraseña",
    "whoAreYou": "¿Quién eres?",
    "otherRole": "Otro, ¿Cuál?",
    "createAccount": "Crear cuenta nueva",
    "signInWithGoogle": "Entrar con Google",
    "signInWithApple": "Entrar con Apple",
    "signUpWithGoogle": "Regístrate con Google",
    "signUpWithApple": "Regístrate con Apple",
    "signInWithEmail": "Entrar con e-mail y contraseña",
    "signUpWithEmail": "Regístrate con e-mail y contraseña",
    "transformEducation": "Tu poder para transformar la educación",
    "recoverPassword": "RECUPERAR CONTRASEÑA",
    "forgotPassword": "He olvidado mi contraseña",
    "register": "Registro",
    "signIn": "Entrar",
    "confirmSignOut": "¿Seguro que quieres cerrar tu sesión en Kokoro Schools?",
    "userTypes": {
      "teacher": "Profesor/a",
      "psychologist": "Psicólogo/a",
      "mother": "Madre",
      "father": "Padre",
      "familyTutor": "Familiar",
      "other": "Otro"
    }
  },
  "snackbar": {
    "initDataError": "Error obteniendo los datos de inicio de la app",
    "signupExistingUserLogin": "Este usuario ya existe. Entra con tu contraseña",
    "signupCreateUserError": "Error al crear el usuario",
    "loginInvalidCredentials": "Error al iniciar sesión. Asegúrate de escribir bien la contraseña",
    "googleSignInError": "Error al iniciar sesión con Google",
    "appleSignInError": "Error al iniciar sesión con Apple",
    "emailUserAlreadyExists": "El usuario ya existe",
    "emailSignUpError": "Error al registrarse",
    "customTokenSignInError": "Error al iniciar sesión con token personalizado",
    "recoverPasswordEmailSent": "Se te ha enviado un email para recuperar tu contraseña",
    "recoverPasswordEmailError": "Error al enviar el email de recuperación de contraseña",
    "gamesScheduledSessionsError": "Error al obtener las sesiones programadas de juegos",
    "allGamesScheduledSessionsError": "Error al obtener todas las sesiones programadas de juegos",
    "sendGamesError": "Error al enviar los juegos",
    "onboardingCheckLearnerName": "Revisa el nombre de tu aprendiz",
    "onboardingCreateUserError": "Ha habido un error al crear tu usuario"
  },
  "validation": {
    "requiredMonth": "Se necesita mes",
    "requiredYear": "Se necesita año",
    "requiredOption": "Se necesita una opción",
    "requiredLanguage": "Se necesita idioma",
    "requiredPrefix": "Se necesita prefijo",
    "requiredCenterType": "Se necesita tipo de centro",
    "requiredSpecialNeeds": "Se necesita nee",
    "invalidEmail": "Este correo electrónico no es válido. Asegúrate de que lo escribes correctamente.",
    "invalidPassword": "La contraseña no es válida",
    "nameMinLength": "El nombre debe tener al menos un carácter",
    "nameInvalidChars": "El nombre contiene caracteres inválidos",
    "passwordsMustMatch": "Las contraseñas deben coincidir",
    "selectProfile": "Selecciona cuál es tu perfil",
    "sessionNameTooLong": "El nombre de la sesión no puede exceder los 20 caracteres.",
    "selectSpecialNeed": "Selecciona una opción de necesidad",
    "selectTimeLimitMinutes": "Selecciona minutos para el tiempo límite",
    "selectProfessionalType": "Selecciona el tipo de profesional y crea tu cuenta"
  },
  "profile": {
    "changeSelectionWarning": "Se borrará toda la selección actual. ¿Seguro que quieres seleccionar otro perfil?",
    "changeSelectionWarningWithSession": "Se borrarán todos los juegos de la sesión del perfil actual ¿Seguro que quieres seleccionar otro perfil?",
    "discardChangesPrompt": "¿Quieres volver sin aplicar los cambios?",
    "profileImage": "Imagen de perfil",
    "settingsFor": "Configuración de {name}",
    "profile": "Perfil",
    "changeImage": "Cambiar imagen",
    "name": "Nombre",
    "birthDate": "Fecha de nacimiento",
    "birthMonth": "Mes de nacimiento",
    "birthYear": "Año de nacimiento",
    "hasSpecialNeeds": "¿Tiene necesidades especiales?",
    "whichSpecialNeeds": "¿Qué necesidades especiales tiene?",
    "whichSpecialNeedsShort": "¿Cuál?",
    "learningLanguage": "Idioma de aprendizaje",
    "whichNeed": "¿Qué necesidad tiene?",
    "prefix": "Prefijo",
    "centerType": "Tipo de centro de trabajo",
    "phone": "Teléfono",
    "learnerName": "Nombre del aprendiz",
    "learnerBirthDate": "¿Cuándo nació tu aprendiz?",
    "hasSpecificSupportNeeds": "¿Tiene alguna necesidad específica de apoyo educativo?",
    "changePhoto": "Cambiar foto",
    "saveProfile": "Guardar perfil",
    "editProfile": "Editar perfil",
    "lockedProfile": "Perfil bloqueado",
    "addProfile": "Añadir perfil",
    "configureProfile": "CONFIGURAR PERFIL",
    "settings": "Configuración",
    "progress": "Progreso",
    "createLearnerProfile": "CREAR PERFIL DE APRENDIZ",
    "unsavedChangesWarning": "Se borrarán todas las modificaciones no guardadas ¿Seguro que quieres seleccionar otro perfil?",
    "downloadProgressPrompt": "Para ver el progreso de {name} descarga la app de Kokoro Kids e inicia sesión con el email",
    "signInWithEmail": "con el email {email}",
    "changeLanguage": "Cambiar idioma"
  },
  "accessibility": {
    "title": "Ajustes de accesibilidad",
    "audio": "Audio",
    "voice": "Voz",
    "musicAndSfx": "Música y SFX",
    "reduceVisualStimuli": "Reducción de estímulos visuales",
    "timeLimit": "Límite de tiempo de juego",
    "minutes": "minutos",
    "chooseTime": "Escoge tiempo",
    "voiceVolume": "Volumen de la voz",
    "musicAndSfxVolume": "Volumen de la música y efectos de sonido",
    "noSettingsSelected": "Sin ajustes de accesibilidad",
    "configure": "Configurar la accesibilidad"
  },
  "specialNeeds": {
    "preferNotToAnswer": "Prefiero no contestar",
    "tea": "TEA",
    "tps": "TPS",
    "di": "DI",
    "ac": "AC",
    "tdah": "TDAH",
    "other": "Otros",
    "downSyndrome": "Síndrome de Down",
    "intellectualDisability": "Discapacidad intelectual",
    "highAbilities": "Altas capacidades",
    "languageDisorder": "Trastorno específico del lenguaje",
    "dyslexia": "Dislexia",
    "dyscalculia": "Discalculia"
  },
  "languages": {
    "spanish": "Español",
    "english": "Inglés",
    "portuguese": "Portugués",
    "indonesian": "Indonesio",
    "unknown": "Idioma desconocido"
  },
  "months": {
    "january": "Enero",
    "february": "Febrero",
    "march": "Marzo",
    "april": "Abril",
    "may": "Mayo",
    "june": "Junio",
    "july": "Julio",
    "august": "Agosto",
    "september": "Septiembre",
    "october": "Octubre",
    "november": "Noviembre",
    "december": "Diciembre"
  },
  "menu": {
    "home": "Inicio",
    "profile": "Perfil",
    "faq": "FAQ"
  },
  "plans": {
    "upgradePlan": "Mejorar plan",
    "currentPlanTitle": "Este es tu plan de Kokoro Schools actual:",
    "upgradePrompt": "¿Quieres llevar tu experiencia educativa al siguiente nivel?",
    "basic": "PLAN BÁSICO",
    "professional": "PLAN PARA PROFESIONALES",
    "schools": "PLAN PARA COLEGIOS",
    "freePrice": "GRATIS",
    "proPrice": "111€/Año",
    "customPrice": "PRECIO PERSONALIZADO",
    "continueFree": "Continuar gratis",
    "upgradeMyPlan": "Mejorar mi plan",
    "requestPlan": "Solicitar este plan",
    "discountBadge": "20% DE DESCUENTO",
    "activeSubscription": "Suscripción activa",
    "limitedVersion": "Versión limitada",
    "trialPeriod": "PERIODO DE PRUEBA",
    "expiresIn": "Expira en",
    "trialExpired": "PERIODO DE PRUEBA EXPIRADO",
    "nextRenewalIn": "Próxima renovación en",
    "viewPlans": "Ver planes",
    "trialEndsIn": "Tu periodo de prueba acaba en {count} días",
    "upgradeForUnlimited": "Mejora tu plan para acceder a perfiles y sesiones ilimitadas",
    "tiers": {
      "basic": "BÁSICO",
      "trial": "PRUEBA",
      "professional": "PROFESIONAL",
      "schools": "COLEGIOS"
    },
    "features": {
      "free": {
        "profile": "1 perfil de alumno",
        "sessions": "3 sesiones educativas mensuales",
        "games": "Más de 200 juegos donde elegir actividades"
      },
      "pro": {
        "profiles": "3 perfiles",
        "unlimitedSessions": "Sesiones ilimitadas",
        "timeSettings": "Ajustes de tiempo de juego",
        "games": "Más de 200 juegos donde elegir actividades",
        "gameCreator": "Creador de juegos (próximamente)",
        "premiumAccess": "Acceso a Kokoro Kids Premium"
      },
      "expert": {
        "limitedProfiles": "Perfiles limitados",
        "unlimitedSessions": "Sesiones ilimitadas",
        "professionalProgram": "Programa de desarrollo profesional",
        "timeSettings": "Ajustes de tiempo de juego",
        "games": "Más de 200 juegos donde elegir actividades",
        "gameCreator": "Creador de juegos (próximamente)",
        "premiumAccess": "Acceso a Kokoro Kids Premium"
      }
    },
    "popup": {
      "features": {
        "unlimitedProfiles": "Perfiles y grupos ilimitados",
        "unlimitedSessions": "Sesiones ilimitadas",
        "premiumKids": "Kokoro Kids premium",
        "activityBook": "Libro de actividades"
      }
    }
  },
  "session": {
    "subtitle": {
      "selectActivities": "Selecciona actividades",
      "chooseSubcategories": "Elige subcategorías",
      "chooseObjectives": "Elige objetivos"
    },
    "create": "Crear sesión",
    "selectGamesPrompt": "Elige los juegos para crear la sesión de aprendizaje",
    "activitiesCount": "({count} actividad) | ({count} actividades)",
    "confirmDeleteSession": "¿Seguro que quieres eliminar esta sesión de juego?",
    "resetAllGames": "Se borrarán todos los juegos de la sesión",
    "confirmRedoSession": "¿Seguro que quieres rehacer la sesión?",
    "confirmSendSession": "¿Seguro que quieres enviar esta sesión a la app?",
    "noActivitiesSelected": "Aún no has seleccionado la sesión de actividades para este aprendiz",
    "startNow": "EMPIEZA AHORA",
    "planNewSession": "Planificar nueva sesión",
    "redoSession": "Rehacer sesión",
    "addMoreActivities": "Añadir más actividades",
    "sendSessionToLearner": "Enviar sesión al aprendiz",
    "monthlyLimitTitle": "Has alcanzado el límite de sesiones mensual",
    "monthlyLimitSubtitle": "Desbloquea sesiones ilimitadas con nuestros planes",
    "sessionDataTitle": "Datos de la sesión de aprendizaje",
    "selectedGamesCount": "{count} Juegos seleccionados",
    "gamesComingSoon": "Juegos de {objectives} próximamente",
    "confirmSendYes": "Sí, enviar sesión",
    "confirmSendNo": "No, seguir explorando",
    "recommendedTitle": "Sesiones recomendadas",
    "recommendedDescription": "Selección de sesiones diseñadas para trabajar temas habituales, adaptadas a las necesidades del alumnado.",
    "customTitle": "Crea tu sesión",
    "customDescription": "Personaliza tu sesión eligiendo los juegos y objetivos que mejor se adapten a tus alumnos y a tu forma de enseñar.",
    "createHowTitle": "¿Cómo quieres crear la sesión?",
    "active": "Sesión activa",
    "previous": "Sesiones anteriores",
    "activeInKokoroKids": "SESIÓN ACTIVA EN KOKORO KIDS",
    "previousInKokoroKids": "SESIONES ANTERIORES EN KOKORO KIDS",
    "defaultName": "Nombre de sesión",
    "createdOn": "CREADA {date}",
    "viewActivities": "Ver actividades",
    "playNow": "¡A JUGAR!",
    "timesPlayed": "Veces jugada",
    "noGamesSelected": "Sin juegos seleccionados",
    "addGame": "Añadir juego",
    "tryGame": "Probar juego",
    "filterGames": "Filtrar juegos",
    "filterAllGames": "Filtrar todos los juegos ({count})",
    "clearAllFilters": "Borrar todos los filtros",
    "play": "Jugar",
    "playedLabel": "Jugada",
    "createdOnLabel": "Creada",
    "playedTimes": "Jugada {count} veces",
    "sessionInLanguage": "Sesión en {language}",
    "noSessions": "Sin sesiones",
    "createFirstSessionPrompt": "No tiene sesiones, ¡crea la primera!",
    "pendingToPlay": "Pendiente de jugar",
    "howToPlay": "¿Cómo puedo jugar?",
    "namePlaceholder": "Escribe aquí el nombre de la sesión",
    "viewGames": "Ver juegos",
    "viewContent": "Ver contenidos"
  },
  "sessionRecommendation": {
    "title": "Recomendación de sesiones",
    "subtitle": "Aquí tienes algunas sesiones que podrían gustarte:",
    "viewGames": "Ver juegos",
    "chooseSession": "Elegir sesión",
    "gamesCount": "{count} juegos"
  },
  "profiles": {
    "congratsTitle": "¡Enhorabuena!",
    "congratsMessage": "Has creado con éxito el perfil de {name}. Empieza a crear una sesión de aprendizaje personalizada pulsando en él.",
    "groupTitle": "TU GRUPO",
    "groupSubtitle": "Personaliza la sesión por aprendiz",
    "preparingSession": "Estamos preparando tu sesión",
    "manageGroup": "Gestiona tu grupo"
  },
  "onboard": {
    "welcomeTitle": "Bienvenida, ¡ya estás dentro de Kokoro Schools!",
    "subtitle": "Explora cómo funciona Kokoro Schools y da tus primeros pasos en la plataforma:",
    "alreadyPlayed": "¿Ya has jugado?",
    "unlockLink": "Pulsa aquí y desbloquea el resto de Kokoro Schools.",
    "register": {
      "title": "Da de alta a tu primer alumno",
      "description": "Las sesiones de aprendizaje están adaptadas a cada alumno, empieza por este paso.",
      "createLearner": "Crear alumno",
      "addLearner": "Añadir alumno",
      "addTestLearner": "Añadir alumno de prueba",
      "sampleLaraName": "Lara",
      "sampleNoaName": "Noa"
    },
    "play": {
      "title": "¡A jugar!",
      "description": "Descarga o abre la app y juega la sesión planificada.",
      "prompt": "Para jugar la sesión descarga la app e inicia sesión con el email que te has dado de alta en Kokoro Schools."
    },
    "learning": {
      "title": "Crea tu primera sesión de aprendizaje",
      "description": "Selecciona los juegos y adapta la sesión para el primer alumno."
    }
  },
  "onboarding": {
    "welcomeTitle": "¡Te damos la bienvenida a Kokoro Schools!",
    "welcomeSubtitle": "Ya puedes empezar a personalizar tus sesiones educativas ¡En minutos!",
    "aboutProfessional": "Cuéntanos sobre ti como profesional",
    "noMarketing": "No quiero recibir noticias, promociones ni contenido gratuito de Kokoro.",
    "createFirstProfileTitle": "Vamos a crear un primer perfil para uno de tus aprendices.",
    "createFirstProfileSubtitle": "Introduce su nombre para empezar a crear sus sesiones en Kokoro Kids",
    "languageQuestion": "¿Quieres que aprenda en su idioma nativo, o en otro?",
    "languageSubtitle": "Las actividades de Kokoro Kids se mostrarán en el idioma que quieras que practique.",
    "accessibilityQuestion": "¿Quieres configurar la accesibilidad?",
    "accessibilitySubtitle": "En base a sus necesidades podrás reducir los estímulos visuales y auditivos. Además podrás añadir un límite de tiempo de juego.",
    "beginTitle": "¡Ya podemos empezar!",
    "beginSteps": {
      "createSession": "CREAR LA PRIMERA SESIÓN DE APRENDIZAJE EN KOKORO SCHOOLS",
      "downloadApp": "DESCARGA KOKORO KIDS EN LA TABLET / SMARTPHONE",
      "signIn": "INICIA SESIÓN CON ESTA CUENTA EN KOKORO KIDS",
      "startLearning": "¡YA PUEDE EMPEZAR A APRENDER CON TU SESIÓN PERSONALIZADA!"
    },
    "letsGo": "¡VAMOS ALLÁ!"
  },
  "home": {
    "discountTitle": "¡Aprovecha el 20% de descuento!",
    "discountSubtitle": "Obtén acceso ilimitado a todas las ventajas de los planes Kokoro Schools",
    "profileLimitTitle": "Has alcanzado el límite de perfiles que puedes crear",
    "profileLimitSubtitle": "Desbloquea perfiles ilimitados nuestros planes",
    "greeting": "Hola, ¡qué bueno verte por aquí!",
    "goToKokoroKids": "Ir a Kokoro Kids",
    "createLearner": "Crear Alumno"
  },
  "faq": {
    "titleShort": "FAQ",
    "title": "Preguntas frecuentes",
    "description1": "Encuentra aquí las respuestas a las dudas más comunes sobre Kokoro Schools.",
    "description2": "Queremos que tu experiencia sea lo más clara y sencilla posible, por eso hemos recopilado la información más importante para ti.",
    "contactPrompt": "¿Tienes más dudas o sugerencias?",
    "contactUs": "Contacta con nosotros"
  },
  "help": {
    "needHelp": "¿Necesitas ayuda?",
    "description": "Estamos aquí para ayudarte a resolver tus dudas. Contacta con nuestro equipo Kokoro Schools",
    "contact": "Contactar"
  },
  "brand": {
    "kokoroKids": "KOKORO KIDS"
  },
  "loginPopup": {
    "title": "¿Quieres utilizar Kokoro Kids con las ventajas de Kokoro Schools?",
    "benefits": {
      "customize": "PERSONALIZA TUS CLASES",
      "prepareQuickly": "PREPARA LAS SESIONES EN MENOS DE UN MINUTO",
      "adaptContent": "ADAPTA EL CONTENIDO A LAS NECESIDADES DEL APRENDIZ"
    },
    "talk": "¿HABLAMOS?",
    "requestAccess": "Solicita acceso",
    "emailSubject": "Solicitar acceso Kokoro Schools",
    "emailBody": "Hola, me gustaría tener acceso a Kokoro Schools."
  },
  "qrPopup": {
    "scanTitle": "Escanea este código QR desde cualquier dispositivo móvil",
    "scanSubtitle": "para descargar o empezar a utilizar Kokoro Kids.",
    "readyToUse": "Ya puedes usar",
    "downloadOrUseNow": "Descárgala o empieza a usarla ahora mismo.",
    "useOnThisDevice": "USAR EN ESTE DISPOSITIVO",
    "useOnOtherDevice": "USAR EN OTRO DISPOSITIVO",
    "manualSignIn": "También puedes iniciar sesión en la app manualmente con la misma cuenta"
  },
  "payment": {
    "successTitle": "¡Suscripción activa!",
    "errorTitle": "Ups!",
    "successSubtitle": "¡Enhorabuena!",
    "errorSubtitle": "Parece que algo ha ido mal.",
    "successDetails": "Ya puedes disfrutar de las ventajas de tu suscripción.",
    "errorDetails": "Comprueba que la información que has introducido es correcta.",
    "continueCreatingSessions": "Seguir creando sesiones",
    "backToPlans": "Volver a los planes"
  },
  "sessionCreated": {
    "title": "¡Sigue estos sencillos pasos para que {name} empiece a jugar!",
    "defaultSessionName": "Sesión educativa",
    "signIn": "Inicia sesión",
    "signInPrompt": "en la app con la misma cuenta.",
    "yourUser": "Tu usuario:",
    "profilePrompt": "En la app aparecerá el perfil de {name}, elígelo y aparecerá la sesión lista para",
    "play": "jugar",
    "nameSession": "Nombra",
    "nameSessionPrompt": "esta sesión de juego de {name}",
    "nameSessionHelp": "Esto te ayudará a recordar los contenidos que está trabajando la sesión.",
    "nameSessionPlaceholder": "Escribe un nombre de sesión",
    "download": "Descarga",
    "downloadPrompt": "la app en la tablet o móvil donde vaya a jugar {name}.",
    "scanQr": "Puedes hacerlo escaneando este QR",
    "openAppPrompt": "Haz click en este botón para abrir la app",
    "openApp": "Abrir la app",
    "searchInStoresPrefix": "O busca",
    "searchInStoresSuffix": "en Google Play o App Store."
  },
  "centerTypes": {
    "publicSchool": "Colegio Público",
    "charterSchool": "Colegio Concertado",
    "privateSchool": "Colegio Privado",
    "specialEducationSchool": "Colegio de Educación Especial",
    "psychologicalOffice": "Gabinete Psicológico",
    "pedagogicalClinic": "Clínica Pedagógica",
    "other": "Otro"
  },
  "groups": {
    "sample": {
      "squirrel": "Clase ardilla",
      "gorilla": "Clase gorila",
      "snail": "Clase caracol",
      "sessionTitle1": "Sesión de discriminación - 5 feb",
      "sessionDate1": "12 febrero 2024",
      "sessionDuration": "10 minutos"
    }
  },
  "routes": {
    "createSession": "Crear sesión",
    "sessionCreated": "Sesión creada correctamente",
    "plans": "Planes",
    "editProfile": "Editar perfil",
    "subscriptionActivated": "Suscripción activada",
    "operationCanceled": "Operación cancelada",
    "maintenance": "Mantenimiento"
  }
}
